import { spriteMap } from '../main/spriteMap-sidecar'
import { IMachine } from './machines'
import { machines } from './machines-sidecar'

function ensure(obj: IMachine) {
  machines.ensureType(obj, 'bed')
}

export function onCreate(obj: IMachine) {
  ensure(obj)
  obj.onUpdate = onUpdate
}

export function onUpdate(obj: IMachine) {
  ensure(obj)

  console.log('occupido', obj.isOccupied)
  if (obj.isOccupied) {
    spriteMap.setFrame(obj.parts[0].image, obj.parts[0].data.frames[1])
    spriteMap.setFrame(obj.parts[1].image, obj.parts[1].data.frames[1])
  } else {
    spriteMap.setFrame(obj.parts[0].image, obj.parts[0].data.frames[0])
    spriteMap.setFrame(obj.parts[1].image, obj.parts[1].data.frames[0])
  }
}
